module.exports = __webpack_public_path__ + "img/pin_black.0373d1c0.svg";